import { render, staticRenderFns } from "./MgrupommppGrid.vue?vue&type=template&id=440653fc"
import script from "./MgrupommppGrid.vue?vue&type=script&lang=js"
export * from "./MgrupommppGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports